// i18next-extract-mark-ns-start menu
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'gatsby-plugin-react-i18next';
import { Link } from '../../../services/link';

import { pushOrderStartToGTM } from '../../CTALink';
import withCustomerContext from '../../../withCustomerContext';
import withOrderContext from '../../../withOrderContext';
import dropDownArrow from '../../../assets/arrow-dropdown-list-light.svg';
import routesMap from '../../../Routes';
import {
  fontWeight, margins, tabletThresholdPixels, Content,
  menuBarHeightPixels, mobileMenuBarHeightPixels,
} from '../v2/styledComponents';
import { colors, frames } from '../v4/styledComponents';
import {
  getServicesList, getAboutList,
} from '../menuData';
import FooterMenuMobileAndSocial from '../FooterMenuMobileAndSocial';
import { shouldShowIfEnglish } from '../../../../languages';

const getHeaderContent = (orderRoute, restart, packagePage, setPackagePath, t) => ([
  {
    index: 0,
    title: t('Nos services'),
    links: getServicesList(t),
    lightBorder: true,
  },
  {
    index: 1,
    title: t('Marque'),
    url: routesMap.WhyBecomePartner.url,
    lightBorder: true,
  },
  {
    index: 2,
    title: t('Artisan'),
    url: routesMap.BeTillistePage.url,
    lightBorder: true,
  },
  {
    index: 3,
    title: t('À propos'),
    links: getAboutList(t),
  },
  {
    index: 4,
    title: t('Prendre soin ici'),
    url: orderRoute,
    onClick: () => packagePage ? setPackagePath(true) && pushOrderStartToGTM(orderRoute, 'MobileMenu', restart) : pushOrderStartToGTM(orderRoute, 'MobileMenu', restart),
    invert: true,
  },
  {
    index: 5,
    title: t('Avis'),
    url: routesMap.CustomerFeedbacksPage.url,
    border: true,
    margin: '8px 0 20px 0',
  },
]);

const StyledLink = styled(Link)`
  width: 100%;
  text-align: start;
`;

const StyledContent = styled(Content)`
  padding: 0px ${frames.mobile} 100px;
  background-color: ${colors.beige100};
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  height: calc(100vh - ${menuBarHeightPixels} - 100px);
  overflow: scroll;
  z-index: 3;
  width: auto;
  @media (max-width: ${tabletThresholdPixels}) {
    width: auto;
    height: calc(100vh - ${mobileMenuBarHeightPixels} - 100px);
  }
`;

const SubContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TextMainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: stretch;
  text-align: center;
`;

const TextContainer = styled.div`
  color: ${colors.black};
  font-size: 12px;
  text-align: left;
  font-weight: ${fontWeight.regular};
  ${(props) => props.link && `padding-bottom: ${margins.s};`}
`;

const MenusContainer = styled.div`
  margin: 20px 0 20px;
  padding: 0px;
`;

const MenuContainer = styled.div`
  margin: 0px;
  ${(props) => props.lightBorder && `
  border-color: ${colors.grey400};
  border-style: solid;
  border-width: 0px 0px 1px;`}
    ${(props) => props.border && `
  border-color: ${colors.grey400};
  border-style: solid;
  border-width: 0px 0px 2px;`}
`;

const MenuTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const MenuTitle = styled.h3`
  ${(props) => props.margin ? `margin: ${props.margin}` : 'margin: 20px 0'};
  ${(props) => props.invert ? `color: ${colors.white};` : `color: ${colors.black};`}
  ${(props) => props.invert && `background-color: ${colors.black}; padding: 10px 10px; text-align: center;`}
  font-size: 12px;
  letter-spacing: 0.5px;
  font-weight: 400;
  text-transform: uppercase;
`;

const Img = styled.img`
  padding-bottom: 1px;
  margin-left: 4px;
  width: 13px;
  ${(props) => props.rotate && 'transform: rotate(180deg)'};
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

class MobileMenu extends React.Component {
  constructor() {
    super();
    this.state = { openedIndex: -1 };
  }

  clickAndClose(onClick) {
    const { close } = this.props;
    close();
    onClick();
  }

  renderUrlContent = (content) => {
    const { onClick } = this.props;
    return (
      <StyledLink
        key={content.url}
        style={{ textDecoration: 'none', color: 'inherit' }}
        to={content.url}
        onClick={() => !content.onClick ? onClick() : this.clickAndClose(content.onClick)}
      >
        <MenuTitle margin={content.margin} invert={content.invert}>{content.title}</MenuTitle>
      </StyledLink>
    );
  };

  renderRegularContent = (content, index) => {
    const { t } = this.props;
    const { openedIndex } = this.state;
    return (
      <Row onClick={() => this.setState({ openedIndex: openedIndex === index ? -1 : index })}>
        <MenuTitle>
          {content.title}
        </MenuTitle>
        <Img
          alt={t('Flèche menu déroulant')}
          src={dropDownArrow}
          rotate={(openedIndex === index) ? 'true' : undefined}
        />
      </Row>
    );
  };

  renderContent(content, index) {
    if (content.url) return this.renderUrlContent(content);
    return this.renderRegularContent(content, index);
  }

  renderHeaderContent = () => {
    const {
      isCustomerLoggedIn, onClick, packagePage, orderContext: { getOrderRouteAndEvent, setPackagePath }, t,
    } = this.props;
    const { openedIndex } = this.state;
    const { orderRoute, restart } = getOrderRouteAndEvent();
    const headerContent = getHeaderContent(orderRoute, restart, packagePage, setPackagePath, t);
    return (headerContent.map((content, index) => (
      <MenuContainer lightBorder={content.lightBorder} border={content.border} key={`${content.title}_mobile`}>
        <MenuTitleContainer>
          {this.renderContent(content, index, isCustomerLoggedIn)}
        </MenuTitleContainer>
        {(openedIndex === index) && content.links
          .filter((link) => shouldShowIfEnglish(link.url))
          .map((link) => (
            <StyledLink
              key={link.url}
              style={{ textDecoration: 'none', color: 'inherit' }}
              to={link.url}
              onClick={() => {
                onClick();
                if (typeof link.onClick === 'function') link.onClick();
              }}
            >
              <TextContainer link>{link.text}</TextContainer>
            </StyledLink>
          ))}
      </MenuContainer>
    )));
  };

  render() {
    return (
      <StyledContent>
        <SubContainer>
          <TextMainContainer>
            <MenusContainer>
              {this.renderHeaderContent()}
            </MenusContainer>
            <FooterMenuMobileAndSocial />
          </TextMainContainer>
        </SubContainer>
      </StyledContent>
    );
  }
}

MobileMenu.propTypes = {
  onClick: PropTypes.func.isRequired,
  isCustomerLoggedIn: PropTypes.bool.isRequired,
  customerContext: PropTypes.shape({
    initializeCustomerContext: PropTypes.func,
  }).isRequired,
  close: PropTypes.func,
  orderContext: PropTypes.shape({
    getOrderRouteAndEvent: PropTypes.func,
    setPackagePath: PropTypes.func,
  }).isRequired,
  packagePage: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

MobileMenu.defaultProps = {
  close() {},
  packagePage: false,
};

export default withTranslation()(withCustomerContext(withOrderContext(MobileMenu)));
